import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref, watch } from "vue";
import { useResizeObserver, useScroll } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressScroll',
  props: {
  top: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const el = ref<HTMLElement>();
const scrollTrack = ref<HTMLElement>();
const scrollThumb = ref<HTMLElement>();
const showScrollBar = ref<boolean>(false);



useResizeObserver(document.body, () => {
  const scrollElement: HTMLElement = el.value?.children[0] as HTMLElement;
  const scrollWidth = scrollElement.scrollWidth;
  let clientWidth = scrollElement.clientWidth;
  if (scrollWidth > clientWidth + 12) {
    showScrollBar.value = true;
    scrollElement.style.overflowX = "auto";
  } else {
    showScrollBar.value = false;
    scrollElement.style.overflowX = "hidden";
  }
});

onMounted(() => {
  const scrollElement: HTMLElement = el.value?.children[0] as HTMLElement;
  const { x } = useScroll(scrollElement);
  watch(x, (currVal) => {
    if (scrollThumb.value && scrollTrack.value) {
      const trackWidth = scrollTrack.value.clientWidth;
      const thumbWidth = scrollThumb.value.clientWidth;
      const scrollWidth = scrollElement.scrollWidth;
      const clientWidth = scrollElement.clientWidth;
      const val = (trackWidth - thumbWidth) * (currVal / (scrollWidth - clientWidth));
      scrollThumb.value.style.left = `${val}px`;
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["scroll", { 'scroll--show-bar': showScrollBar.value }]),
    ref_key: "el",
    ref: el
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (showScrollBar.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["scroll__bar", { 'scroll__bar--top': __props.top }]),
          ref_key: "scrollTrack",
          ref: scrollTrack
        }, [
          _createElementVNode("div", {
            class: "scroll__thumb",
            ref_key: "scrollThumb",
            ref: scrollThumb
          }, null, 512)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})